// 한국어 사전 — 단일 진실원본 (TranslationKey가 이 타입에서 파생)
export const ko = {
  // ── 공통 ────────────────────────────────────────────────────────
  'common.loading': '로딩 중…',
  'common.cancel': '취소',
  'common.save': '저장',
  'common.confirm': '확인',
  'common.close': '닫기',
  'common.search': '검색',
  'common.refresh': '새로고침',
  'common.delete': '삭제',
  'common.edit': '편집',
  'common.required': '필수',
  'common.optional': '선택',
  'common.theme.toggle': '테마 전환 (현재: {{theme}})',
  'common.menu.open': '메뉴 열기',
  'common.menu.close': '메뉴 닫기',
  'common.logout': '로그아웃',
  'common.lang.toggle': '언어 전환 (현재: {{lang}})',
  'common.skipNav': '본문 바로가기',
  'common.units.count': ' 건',
  'common.units.people': ' 명',
  'common.units.ea': ' 개',
  'common.units.percent': '%',
  'common.units.minutes': '분',
  'common.units.hours': '시간',
  'common.units.days': '일',
  'common.empty': '데이터 없음',
  'common.success': '성공',
  'common.error': '실패',
  'common.notifications': '알림',
  'common.start': '시작',
  'common.complete': '완료',
  'common.create': '생성',
  'common.issue': '발행',
  'common.send': '송신',
  'common.run': '실행',
  'common.calc': '계산',
  'common.apply': '적용',
  'common.ack': '인지',
  'common.resolve': '해소',
  'common.target': '목표',
  'common.actual': '실측',
  'common.variance': '차이',
  'common.now': '방금',
  'common.minutesAgo': '{{n}}분 전',
  'common.hoursAgo': '{{h}}시간 {{m}}분 전',
  'common.daysAgo': '{{n}}일 전',

  // ── 브랜드 ───────────────────────────────────────────────────────
  'brand.name': '컴앤정밀',
  'brand.suffix': 'MES',
  'brand.home': '컴앤정밀 MES 홈',

  // ── NAV ─────────────────────────────────────────────────────────
  'nav.dashboard': '대시보드',
  'nav.andon': 'Andon',
  'nav.production': '생산오더',
  'nav.workOrders': '작업지시',
  'nav.equipmentData': '실적수집',
  'nav.inspection': '품질검사',
  'nav.spc': 'SPC',
  'nav.lots': 'LOT 추적',
  'nav.equipmentStatus': '설비모니터링',
  'nav.maintenance': '보전',
  'nav.labor': '근무현황',
  'nav.boms': 'BOM',
  'nav.schedule': '스케줄',
  'nav.forecasting': '수요예측',
  'nav.cost': '원가',
  'nav.inventory': '재고',
  'nav.primary': '주요 메뉴',
  'nav.full': '전체 메뉴',
  'nav.allMenu': '전체 메뉴 항목',
  'nav.group.operations': '운영',
  'nav.group.quality': '품질',
  'nav.group.equipment': '설비',
  'nav.group.planning': '계획',
  'nav.group.master': '마스터',
  'nav.group.expand': '하위 메뉴 열기',
  'nav.audit': '감사로그',

  // ── Login ───────────────────────────────────────────────────────
  'login.title': '로그인',
  'login.subtitle': '컴앤정밀 MES에 접속하려면 인증해주세요.',
  'login.email': '이메일',
  'login.password': '비밀번호',
  'login.submit': '로그인',
  'login.submitting': '인증 중…',
  'login.success': '로그인되었습니다.',
  'login.failed': '로그인에 실패했습니다.',
  'login.demo': '체험 계정으로 둘러보기',
  'login.demoHint': '읽기 전용 · 데이터 변경 불가',
  'login.demoSuccess': '데모 계정으로 접속했습니다.',
  'demo.banner': '데모 모드 — 읽기 전용 체험 환경입니다. 도입 문의: admin@comnjeong.local',

  // ── Dashboard ───────────────────────────────────────────────────
  'dashboard.realtimeBadge': '실시간 운영 현황',
  'dashboard.hero1': '현장의 모든 데이터를',
  'dashboard.hero2': '한 화면에',
  'dashboard.intro': 'Uniflow-ERP와 PLC/3D 측정기를 5분 주기로 동기화하고, OEE·불량률·작업지시 흐름을 실시간으로 추적합니다.',
  'dashboard.avgOEE': '평균 OEE',
  'dashboard.avgOEE.note': '가동률 × 성능률 × 양품률 (최신 보고치 평균)',
  'dashboard.runningWO': '진행 중 작업지시',
  'dashboard.defectRate30d': '30일 불량률',
  'dashboard.productionOrders': '생산오더',
  'dashboard.productionOrders.note': 'Uniflow-ERP로부터 수신·계획·릴리즈된 전체 누적',
  'dashboard.andonOpen': 'Andon 진행',
  'dashboard.pmDue7d': '보전 7일 내 만기 {{n}}건',
  'dashboard.onDuty': '근무중',
  'dashboard.inventoryAccuracy': '재고 {{pct}}%',
  'dashboard.inventoryEmpty': '재고 실사 미수행 (목표 99.5%)',
  'dashboard.eqStatusTitle': '설비별 최신 OEE',
  'dashboard.swipeHint': '좌우 스와이프 가능',
  'dashboard.eqMetrics.operation': '가동',
  'dashboard.eqMetrics.performance': '성능',
  'dashboard.eqMetrics.quality': '양품',

  // ── Trust ───────────────────────────────────────────────────────
  'trust.iso': 'ISO 27001 준수 설계',
  'trust.encryption': '저장·전송 암호화',
  'trust.audit': '감사로그 100%',
  'trust.online': '현장 사용자 {{n}}명 접속 중',

  // ── Toast ───────────────────────────────────────────────────────
  'toast.unauthorized': '인증이 필요합니다.',
  'toast.forbidden': '권한이 없습니다.',
  'toast.networkError': '네트워크 오류',
  'toast.fetchFailed': '데이터를 불러오지 못했습니다.',
  'toast.actionFailed': '작업 실패',
  'toast.saved': '저장되었습니다.',
  'toast.created': '생성되었습니다.',
  'toast.deleted': '삭제되었습니다.',

  // ── 언어 ────────────────────────────────────────────────────────
  'lang.ko': '한국어',
  'lang.en': 'English',

  // ── Account ─────────────────────────────────────────────────────
  'acct.title': '계정 설정',
  'acct.intro': '본인 정보 확인 및 비밀번호 변경. 비밀번호 변경 시 다른 모든 세션은 즉시 로그아웃됩니다.',
  'acct.profile.title': '내 정보',
  'acct.profile.email': '이메일',
  'acct.profile.name': '이름',
  'acct.profile.roles': '역할',
  'acct.profile.tenant': '테넌트',
  'acct.pw.title': '비밀번호 변경',
  'acct.pw.current': '현재 비밀번호',
  'acct.pw.new': '새 비밀번호',
  'acct.pw.confirm': '새 비밀번호 확인',
  'acct.pw.policy': '12자 이상, 대문자/소문자/숫자/특수문자 중 3종 이상.',
  'acct.pw.mismatch': '새 비밀번호 확인이 일치하지 않습니다.',
  'acct.pw.same': '새 비밀번호는 현재 비밀번호와 달라야 합니다.',
  'acct.pw.submit': '비밀번호 변경',
  'acct.pw.success': '비밀번호가 변경되었습니다. 다른 세션은 모두 로그아웃되었습니다.',
  'acct.pw.strengthLow': '약함',
  'acct.pw.strengthMid': '적정',
  'acct.pw.strengthHigh': '강함',
  'nav.account': '계정',

  // ── Production Orders ───────────────────────────────────────────
  'po.title': '생산오더 수신',
  'po.intro': 'Uniflow-ERP에서 수신된 생산오더 목록입니다. 5분 주기 자동 수신 + 수동 수신을 지원합니다.',
  'po.receive': '오더 수신',
  'po.received': '{{n}}건의 생산오더를 수신했습니다.',
  'po.empty': '수신된 생산오더가 없습니다.',
  'po.emptyHint': 'Uniflow-ERP가 5분 주기로 자동 수신하거나 상단의 "오더 수신" 버튼으로 수동 트리거할 수 있습니다.',
  'po.col.id': '오더 ID',
  'po.col.item': '품번',
  'po.col.quantity': '수량',
  'po.col.due': '납기',
  'po.col.priority': '우선순위',
  'po.col.status': '상태',
  'po.aria.table': '생산오더 목록',
  'po.noWritePerm': '쓰기 권한이 없습니다.',

  // ── Work Orders ─────────────────────────────────────────────────
  'wo.title': '작업지시',
  'wo.new': '새 작업지시',
  'wo.field.poId': '생산오더 ID',
  'wo.field.line': '라인',
  'wo.field.equipment': '설비',
  'wo.field.worker': '작업자',
  'wo.field.startDate': '시작일',
  'wo.field.endDate': '종료일',
  'wo.created': '작업지시가 생성되었습니다.',
  'wo.empty': '발행된 작업지시가 없습니다.',
  'wo.emptyHint': '위의 "새 작업지시" 폼에서 발행할 수 있습니다.',
  'wo.col.id': '작업지시',
  'wo.col.poId': '생산오더',
  'wo.col.item': '품번',
  'wo.col.line': '라인',
  'wo.col.equipment': '설비',
  'wo.col.worker': '작업자',
  'wo.col.period': '기간',
  'wo.col.status': '상태',
  'wo.aria.table': '작업지시 목록',

  // ── Equipment Data ──────────────────────────────────────────────
  'eqd.title': '설비 자동 데이터 수집',
  'eqd.intro': 'OPC-UA · Modbus TCP · MELSEC · S7 게이트웨이가 1초 이내로 데이터를 전송합니다.',
  'eqd.panel': '실시간 송신 패널',
  'eqd.selectEq': '설비 선택',
  'eqd.send': '{{status}} 송신',
  'eqd.sent': '{{eq}} → {{status}} 데이터 전송 완료',
  'eqd.registered': '등록된 설비',
  'eqd.col.id': '설비 ID',
  'eqd.col.name': '이름',
  'eqd.col.type': '유형',
  'eqd.col.protocol': '프로토콜',
  'eqd.aria.list': '설비 목록',

  // ── Inspection ──────────────────────────────────────────────────
  'insp.title': '품질 검사',
  'insp.intro': '3D 측정기(Mitutoyo / Zeiss)에서 자동 수집되는 측정값과 합·부 판정입니다.',
  'insp.manual': '수동 입력',
  'insp.field.wo': '작업지시',
  'insp.field.measurement': '측정값(mm)',
  'insp.field.judgment': '판정',
  'insp.saved': '검사 데이터 {{judgment}} 저장됨',
  'insp.empty': '수집된 검사 데이터가 없습니다.',
  'insp.emptyHint': '3D 측정기에서 자동 수집되거나, 위의 "수동 입력" 폼으로 저장할 수 있습니다.',
  'insp.col.id': '검사 ID',
  'insp.col.wo': '작업지시',
  'insp.col.measurement': '측정값',
  'insp.col.judgment': '판정',
  'insp.col.collectedAt': '수집 시각',
  'insp.aria.table': '검사 데이터 목록',

  // ── Equipment Status ────────────────────────────────────────────
  'eqs.title': '설비 가동 모니터링',
  'eqs.intro': '최신 OEE = 가동률 × 성능률 × 양품률. 15초 주기로 자동 새로고침.',
  'eqs.metric.operation': '가동률',
  'eqs.metric.performance': '성능률',
  'eqs.metric.quality': '양품률',
  'eqs.metric.oee': 'OEE',
  'eqs.aria.cards': '설비별 OEE 카드',

  // ── Andon ───────────────────────────────────────────────────────
  'andon.title': 'Andon 보드',
  'andon.intro': '진행 중 이상 알람 · 우선순위 색 코딩 · 15초 자동 새로고침',
  'andon.autoRefresh': '자동 갱신',
  'andon.kpi.open': '진행 중',
  'andon.kpi.mttr': '평균 해소 시간 (7일)',
  'andon.kpi.resolved': '해소 (7일)',
  'andon.open.title': '진행 중 알람',
  'andon.empty': '현재 진행 중인 알람이 없습니다.',
  'andon.ackedBy': '인지 by {{user}} · {{at}}',
  'andon.recent.title': '최근 24시간 해소 이력',
  'andon.modal.title': '알람 해소',
  'andon.modal.note': '조치 내용 (필수)',
  'andon.modal.placeholder': '예: 냉각수 보충 후 모터 정상화 확인',
  'andon.modal.action': '해소 처리',
  'andon.acked': '인지 처리됨',
  'andon.resolved': '해소 완료',

  // ── SPC ─────────────────────────────────────────────────────────
  'spc.title': 'SPC (X̄–R)',
  'spc.intro': '측정값 부분집단(n={{n}})의 평균/범위와 3σ 관리한계(UCL/LCL), 공정능력(Cp / Cpk)을 실시간 산출합니다.',
  'spc.selectCh': '측정 항목 선택',
  'spc.spec': '규격',
  'spc.ooc': '관리이탈 {{n}}건',
  'spc.cpkGrade.excellent': '뛰어남',
  'spc.cpkGrade.adequate': '적합',
  'spc.cpkGrade.marginal': '경계',
  'spc.cpkGrade.inadequate': '부적합',
  'spc.chart.xbar': 'X̄ 차트',
  'spc.chart.r': 'R 차트',
  'spc.ooc.title': '관리이탈 상세',
  'spc.ooc.subgroup': 'subgroup #{{n}}',
  'spc.warnInsufficient': 'subgroup ≥ 2 필요',

  // ── LOT Trace ───────────────────────────────────────────────────
  'lot.title': 'LOT 추적',
  'lot.intro': '제품 LOT 하나로 자재 LOT · 작업지시 · 설비 · 검사 결과 · 동시 알람까지 5초 안에 역추적합니다.',
  'lot.search': 'LOT/품번 검색',
  'lot.empty': '일치하는 제품 LOT이 없습니다.',
  'lot.col.lot': '제품 LOT',
  'lot.col.item': '품번',
  'lot.col.qty': '수량',
  'lot.col.wo': '작업지시',
  'lot.col.equipment': '설비',
  'lot.col.producedAt': '생산시각',
  'lot.col.quality': '품질',
  'lot.action.trace': '역추적',
  'lot.traceDone': '역추적 완료 ({{ms}}ms)',
  'lot.section.material': '소비된 자재 LOT ({{n}})',
  'lot.section.materialEmpty': '계보 정보 없음',
  'lot.section.events': '검사 ({{insp}}) / 동시 알람 ({{alarm}})',
  'lot.section.inspectionEmpty': '검사 기록 없음',
  'lot.section.alarmEmpty': '동시 알람 없음',
  'lot.meta.item': '품번',
  'lot.meta.qty': '수량',
  'lot.meta.equipment': '설비',
  'lot.meta.line': '라인',
  'lot.meta.worker': '작업자',
  'lot.meta.produced': '생산',

  // ── Maintenance ─────────────────────────────────────────────────
  'maint.title': '보전 (Maintenance)',
  'maint.intro': '예방·교정·예지·정밀 보전 계획과 실적. 설비별 MTBF · MTTR · 가용률을 최근 30일 기준으로 자동 산출합니다.',
  'maint.kpi.availability': '가용률 (30일)',
  'maint.kpi.faultless': '무결',
  'maint.kpi.failures': '{{n}}회 고장',
  'maint.plans.title': '예방 보전 계획',
  'maint.plans.empty': '활성 보전 계획이 없습니다.',
  'maint.col.equipment': '설비',
  'maint.col.planName': '계획명',
  'maint.col.type': '유형',
  'maint.col.cycle': '주기',
  'maint.col.estimated': '예상',
  'maint.col.lastDone': '최근 수행',
  'maint.col.due': '만기',
  'maint.due.today': '오늘',
  'maint.due.future': '{{n}}일 후',
  'maint.due.overdue': '{{n}}일 경과',
  'maint.open.title': '진행/예정 작업 ({{n}})',
  'maint.open.empty': '처리 대기 중인 작업이 없습니다.',
  'maint.col.moId': '작업',
  'maint.col.status': '상태',
  'maint.col.assignee': '담당',
  'maint.col.problem': '증상/예정',
  'maint.recent.title': '최근 완료 ({{n}})',
  'maint.col.completed': '완료',
  'maint.col.downtime': '다운타임',
  'maint.col.resolution': '조치',
  'maint.startDone': '작업 시작',
  'maint.completeDone': '작업 완료',
  'maint.modal.complete': '작업 완료 — {{id}}',
  'maint.modal.resolution': '조치 내용 (필수)',
  'maint.modal.resolutionPh': '예: 베어링 교체 + 윤활유 보충',
  'maint.modal.downtime': '가동중단 시간(분) — 예방보전이면 0',
  'maint.modal.downtimePh': '예: 75',
  'maint.modal.action': '완료 처리',

  // ── Labor ───────────────────────────────────────────────────────
  'labor.title': '근무현황 (Labor)',
  'labor.intro': '작업자 마스터, 교대 정의, 출퇴근(clock-in/out) — 작업지시 배정과 안전관리의 기반.',
  'labor.kpi.onDuty': '현재 근무중',
  'labor.kpi.onDutyHint': '전체 활성 {{total}}명 중 {{pct}}%',
  'labor.kpi.workers': '작업자',
  'labor.kpi.shifts': '교대 정의',
  'labor.workers.title': '작업자',
  'labor.col.id': 'ID',
  'labor.col.name': '이름',
  'labor.col.role': '역할',
  'labor.col.department': '부서',
  'labor.col.certs': '자격',
  'labor.col.currentStatus': '현재 상태',
  'labor.onDuty.duration': '근무중 · {{dur}}',
  'labor.offDuty': 'off duty',
  'labor.clockIn': '출근',
  'labor.clockOut': '퇴근',
  'labor.clockedIn': '{{id}} 출근 처리',
  'labor.clockedOut': '{{id}} 퇴근 처리',
  'labor.shifts.title': '교대 정의',
  'labor.attendance.title': '최근 출퇴근',
  'labor.attendance.empty': '출퇴근 기록 없음',
  'labor.modal.title': '교대 선택 — {{id}}',
  'labor.modal.hint': '출근할 교대조를 선택하세요 (생략 가능).',
  'labor.modal.skip': '교대 없이 출근',

  // ── BOM ─────────────────────────────────────────────────────────
  'bom.title': 'BOM (자재명세서)',
  'bom.intro': '제품 품번별 자재 구성과 소요량(scrap 반영). 생산 수량을 입력하면 자재별 필요량을 즉시 계산합니다.',
  'bom.list.title': '활성 BOM',
  'bom.list.empty': '활성 BOM이 없습니다.',
  'bom.detail.itemCount': '{{n}} 자재 · 기준 {{qty}} {{uom}}',
  'bom.detail.base': '기준 {{qty}} {{uom}}',
  'bom.items.title': '구성 자재 ({{n}})',
  'bom.col.position': '#',
  'bom.col.component': '자재 품번',
  'bom.col.qtyPer': '소요량/단위',
  'bom.col.uom': 'UoM',
  'bom.col.scrap': '스크랩%',
  'bom.explode.title': '소요량 계산 (explode)',
  'bom.explode.qty': '생산 수량 ({{uom}})',
  'bom.explode.calc': '계산',
  'bom.explode.result': '{{item}} {{qty}} {{uom}} 생산 시 필요 자재:',
  'bom.col.gross': '기본',
  'bom.col.scrapQty': '스크랩',
  'bom.col.required': '총 필요량',

  // ── Schedule ────────────────────────────────────────────────────
  'sched.title': '생산 스케줄 (Gantt)',
  'sched.intro': '라인별 작업지시 시간축. 클릭으로 우선순위 조정(긴급 끼워넣기).',
  'sched.days': '{{n}}일',
  'sched.empty': '해당 기간에 스케줄된 작업이 없습니다.',
  'sched.legend.urgent': '긴급 priority 1-2',
  'sched.legend.hint': '막대 클릭 → 우선순위 조정',
  'sched.modal.priority': '우선순위 (1 = 최긴급, 9 = 최저)',
  'sched.modal.urgent': '긴급(1)',
  'sched.adjusted': '{{id}} priority → {{prio}}',

  // ── Forecasting ─────────────────────────────────────────────────
  'fc.title': 'AI 수요 예측',
  'fc.intro': '과거 수요 시계열에서 미래 N일을 예측합니다. SMA · EMA · Holt-Winters(트렌드+주간 계절성) 비교 가능.',
  'fc.field.item': '품번',
  'fc.field.algo': '알고리즘',
  'fc.field.horizon': '예측 기간(일)',
  'fc.run': '예측 실행',
  'fc.empty': '품번과 알고리즘을 선택한 후 "예측 실행"을 눌러주세요.',
  'fc.algo.sma': 'SMA (단순 이동평균)',
  'fc.algo.ema': 'EMA (지수 가중평균)',
  'fc.algo.hw': 'Holt-Winters (트렌드+계절성)',
  'fc.kpi.mape': '예측 정확도 (MAPE)',
  'fc.kpi.mape.note': '낮을수록 좋음 · holdout 검증',
  'fc.kpi.recommended': '추천 발주량',
  'fc.kpi.recommended.note': 'Lead time {{lead}}일 + 안전재고 {{safety}}',
  'fc.kpi.cost': '표준 원가',
  'fc.chart.window': '과거 {{hist}}일 · 예측 {{horizon}}일',
  'fc.chart.legend.actual': '실측',
  'fc.chart.legend.forecast': '예측',
  'fc.chart.legend.ci': '95% 신뢰구간',
  'fc.detail.title': '예측 상세',
  'fc.col.date': '일자',
  'fc.col.forecast': '예측',
  'fc.col.lower': '하한 (95%)',
  'fc.col.upper': '상한 (95%)',
  'fc.runDone': '예측 완료 (MAPE {{mape}}%)',
  'fc.fail': '예측 실패',
  'fc.mode.single': '단일',
  'fc.mode.compare': '비교',
  'fc.compare.run': '모델 비교',
  'fc.compare.bestPick': '자동 선택 (best)',
  'fc.compare.title': '알고리즘 비교 — MAPE 순위',
  'fc.compare.col.rank': '순위',
  'fc.compare.col.algo': '알고리즘',
  'fc.compare.col.mape': 'MAPE',
  'fc.compare.col.mae': 'MAE',
  'fc.compare.col.rmse': 'RMSE',
  'fc.compare.bestBadge': 'BEST',
  'fc.compare.done': '비교 완료 — {{best}} 선정 (MAPE {{mape}}%)',
  'fc.compare.legend.actual': '실측',
  'fc.compare.legend.best': '{{name}} (best)',
  'fc.compare.legend.other': '기타 알고리즘',

  // ── Cost ────────────────────────────────────────────────────────
  'cost.title': '원가 (Cost Roll-up)',
  'cost.intro': '다단계 BOM을 펼친 후 자재별 표준 단가를 곱해 제품 표준 원가를 자동 산출합니다. sub-assembly는 자식 자재 합으로 분해되어 중복 계산을 방지합니다.',
  'cost.field.topItem': '최상위 품번',
  'cost.field.qty': '생산 수량',
  'cost.run': '원가 계산',
  'cost.kpi.produce': '생산 수량',
  'cost.kpi.total': '표준 원가 (총액)',
  'cost.kpi.unit': '단위 원가',
  'cost.kpi.margin': '표준단가 - 실원가',
  'cost.kpi.standardCost': '기준 단가 {{cost}}',
  'cost.missing.title': '단가 미등록 자재 {{n}}건',
  'cost.missing.note': '아래 자재는 item_master.standard_cost가 비어 있어 원가에 포함되지 않았습니다.',
  'cost.tree.title': '다단계 BOM 분해 ({{n}}건)',
  'cost.col.component': '구성',
  'cost.col.required': '필요량',
  'cost.col.unitCost': '단가',
  'cost.col.amount': '금액',
  'cost.col.kind': '구분',
  'cost.col.total': '합계',
  'cost.subDecomposed': '(자식 자재 합으로 분해)',
  'cost.kind.subassembly': 'sub-assy',
  'cost.kind.leaf': 'leaf · L{{level}}',
  'cost.wo.title': '작업지시 원가 — Estimated vs Actual',
  'cost.col.estimated': '표준 원가',
  'cost.col.actual': '실제 원가',
  'cost.col.variance': '차이',

  // ── Inventory ───────────────────────────────────────────────────
  'inv.title': '재고 + WIP',
  'inv.intro': '자재 LOT 위치별 잔량 / 이동·소비 이력 / 실사 정확도 (목표 99.5%) / 진행 중 작업지시의 자재 issue 진척.',
  'inv.kpi.accuracy': '재고 정확도 (30일)',
  'inv.kpi.accuracyHint': '목표 {{target}}% · 표본 {{n}}건',
  'inv.kpi.availLots': '가용 자재 LOT',
  'inv.kpi.value': '재고 평가액',
  'inv.kpi.locations': '위치',
  'inv.balance.title': '잔량',
  'inv.filter.all': '전체',
  'inv.balance.empty': '해당 위치에 잔량 LOT 없음.',
  'inv.col.lot': 'LOT',
  'inv.col.item': '품번',
  'inv.col.location': '위치',
  'inv.col.status': '상태',
  'inv.col.initial': '초기 입고',
  'inv.col.onHand': '현재 잔량',
  'inv.col.value': '평가액',
  'inv.consumedPct': '({{pct}}% 소비)',
  'inv.action.count': '실사',
  'inv.wip.title': 'WIP — 작업지시별 자재 issue vs BOM 요구',
  'inv.wip.empty': '진행 중 작업지시 없음.',
  'inv.wip.bomMissing': 'BOM 미정의',
  'inv.wip.col.material': '자재',
  'inv.wip.col.required': '요구',
  'inv.wip.col.issued': '이슈',
  'inv.wip.col.variance': '차이',
  'inv.wip.col.pct': '%',
  'inv.wip.col.status': '상태',
  'inv.txn.title': '최근 30일 트랜잭션',
  'inv.txn.empty': '트랜잭션 없음.',
  'inv.txn.col.time': '시각',
  'inv.txn.col.type': '타입',
  'inv.txn.col.qty': '수량',
  'inv.txn.col.note': '비고',
  'inv.txn.consume': '소비',
  'inv.count.modal': '실사 — {{lot}}',
  'inv.count.systemQty': '{{item}} · 시스템 잔량 {{qty}} {{uom}}',
  'inv.count.field': '실측 수량 ({{uom}})',
  'inv.count.action': '실사 등록',
  'inv.count.result': '정확도 {{pct}}% · 차이 {{variance}}',
} as const

export type TranslationKey = keyof typeof ko
